import Icon from '@tiger/icons';
import { useEffect, useState } from 'react';
import { Collapse as CollapseBase } from 'react-bootstrap';
import classlist from 'utils/classlist';
import { isEmptyValue } from 'utils/helper';
import styles from './style.scss';

interface CollapseProps {
    className?: string;
    headerClassName?: string;
    defaultExpand?: boolean;
    expanded?: boolean;
    onChange?: (isOpen: boolean) => void;
    title: React.ReactNode;
    children: React.ReactElement;
}

const Collapse: React.FC<CollapseProps> = ({
    expanded,
    defaultExpand,
    title,
    children,
    className,
    headerClassName,
    onChange
}) => {
    const [isOpen, setIsOpen] = useState(Boolean(expanded || defaultExpand));

    const handleToggle = (value: boolean) => {
        if (onChange) {
            onChange(value);
        } else {
            setIsOpen(value);
        }
    };

    useEffect(() => {
        if (!isEmptyValue(expanded)) {
            setIsOpen(expanded!);
        }
    }, [expanded]);

    return (
        <div className={classlist(styles.root, className)}>
            <div
                onClick={() => handleToggle(!isOpen)}
                className={classlist(styles['customer-header'], headerClassName, {
                    [styles['has-open']]: isOpen
                })}>
                <div className={styles.title}>{title}</div>
                <Icon type="right" className={styles['triangle-icon']} />
            </div>
            <CollapseBase in={isOpen}>
                <div className={styles['children-container']}>{children}</div>
            </CollapseBase>
        </div>
    );
};

export default Collapse;
